import { useIntlModule } from 'utils/intl/useIntlModule';
import messages from './sftp.intl.json';

export const useSftpIntl = () => useIntlModule(messages);
